import Base from '@studiometa/js-toolkit';
import CycleCards from './CycleCards';

/**
 * Slider Holder
 */
export default class Cycle extends Base {
  /**
   * Class config.
   * @return {Object}
   */
  get config() {
    return {
      name: 'Cycle',
      refs: [
        'tabs[]',
        'tabContent[]',
        'title[]',
        'container[]',
        'selector',
        'dropdown',
        'selectorLabel',
      ],
      components: {
        CycleCards,
      },
    };
  }

  /**
   * Set variables
   * @return {void}
   */
  mounted() {
    this.currentTabContent = this.$refs.tabContent.find((tab) => tab.dataset.index === '0');
    this.currentTab = this.$refs.tabs.find((tab) => tab.dataset.index === '0');
    this.prevTabContent = null;
    this.currentIndex = 0;
  }

  /**
   * Click on tabs
   * @param  {Object} e element
   * @return {void}
   */
  onTabsClick(e) {
    const { index } = e.currentTarget.dataset;
    if (this.currentIndex === index) {
      return;
    }

    // Change tab state
    this.currentTab.classList.remove('is-active');
    this.currentTab = e.currentTarget;
    this.currentTab.classList.add('is-active');

    this.$refs.selectorLabel.textContent = this.currentTab.querySelector('span').textContent;

    this.$refs.dropdown.classList.remove('is-showing');

    // Change content of tab
    this.prevTabContent = this.currentTabContent;
    this.currentIndex = index;

    this.currentTabContent = this.$refs.tabContent.find(
      (tab) => tab.dataset.index === this.currentIndex
    );
    this.prevTabContent.classList.remove('is-active');
    this.currentTabContent.classList.add('is-active');

    this.updateChildren();
  }

  /**
   * Update Sliders when changing tab
   * @return {void}
   */
  updateChildren() {
    this.$children.CycleCards.forEach((element) => {
      element.reloadFlickity();
    });
  }

  /**
   * For mobile, click on title and open content
   * @param  {Object} e element
   * @return {void}
   */
  onTitleClick(e) {
    const { index } = e.currentTarget.dataset;
    const container = this.$refs.container.filter((tab) => tab.dataset.index === index);

    container.forEach((element) => {
      if (element.classList.contains('hidden')) {
        element.classList.remove('hidden');
      } else {
        element.classList.add('hidden');
      }
    });
  }

  /**
   * Open dropdown
   * @return {void}
   */
  onSelectorClick() {
    this.$refs.dropdown.classList.toggle('is-showing');
  }
}
